import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const ROADPROPERTYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.RoadPropertyType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.RoadPropertyType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const ROADPROPERTYTYPE_CONFIG = {
  entityName: 'RoadPropertyType',
  localizationKey: 'General::Entity.RoadPropertyType',
  fields: ROADPROPERTYTYPE_FIELDS,
  permission: 'Road.RoadPropertyTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Road + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
